import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useDesign } from "./DesignContext";
import { motion } from "framer-motion";

const NameInput = () => {
  const { name, setName } = useDesign();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: `
          radial-gradient(ellipse 80% 60% at 70% 0%, #f3e6fa 60%, transparent 100%),
          linear-gradient(120deg, #f8f6ed 60%, #f3e6fa 100%)
        `,
        backgroundColor: "#f8f6ed",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Floating playful shape for delight */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: -80, sm: -120 },
          left: { xs: -60, sm: -100 },
          width: { xs: 220, sm: 340 },
          height: { xs: 180, sm: 260 },
          background:
            "radial-gradient(circle at 60% 40%, #e9d5ff 60%, transparent 100%)",
          zIndex: 0,
          filter: "blur(8px)",
          opacity: 0.7,
          pointerEvents: "none",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ width: "100%", maxWidth: 480 }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            mb: 2,
            fontWeight: 600,
            color: "#4a3b8f",
          }}
        >
          Add your name
        </Typography>

        <Typography
          sx={{
            textAlign: "center",
            mb: 4,
            color: "#666",
            fontSize: "1.1rem",
          }}
        >
          We'll sign the card so they know who it's from.
        </Typography>

        <TextField
          fullWidth
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          variant="outlined"
          sx={{
            mb: 4,
            "& .MuiOutlinedInput-root": {
              borderRadius: "16px",
              backgroundColor: "white",
              "& fieldset": {
                borderColor: "rgba(124,92,255,0.2)",
              },
              "&:hover fieldset": {
                borderColor: "rgba(124,92,255,0.4)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7c5cff",
              },
            },
          }}
        />

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Button
            component={Link}
            to="/memo-card/preview"
            variant="outlined"
            fullWidth
            sx={{
              py: 2,
              fontSize: "1.1rem",
              fontWeight: 600,
              borderRadius: "16px",
              borderColor: "rgba(124,92,255,0.3)",
              color: "#666",
              "&:hover": {
                borderColor: "rgba(124,92,255,0.5)",
                backgroundColor: "rgba(124,92,255,0.04)",
              },
            }}
          >
            Skip
          </Button>
          <Button
            component={Link}
            to="/memo-card/preview"
            variant="contained"
            fullWidth
            sx={{
              py: 2,
              fontSize: "1.1rem",
              fontWeight: 600,
              borderRadius: "16px",
              background: "linear-gradient(90deg, #a855f7, #f472b6)",
              color: "white",
              boxShadow: "0 2px 12px 0 rgba(168,85,247,0.10)",
              "&:hover": {
                background: "linear-gradient(90deg, #b366f8, #f583c0)",
                boxShadow: "0px 0px 16px rgba(168,85,247,0.2)",
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
};

export default NameInput;
